import React from "react";
import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <div className="footer">
      <div className="container">
        <div className="row">
          <div className="col-md-6">
            <img
              src="./images/tamizhtechielogo.png"
              className="img-fluid"
              alt=""
            />
            {/* <h2>
              Thanks for spotting us at our corner of the internet. We are aimed
              to share the insights of technology in our mother tongue to the
              readers. We are focused on breaking the myth that “Technology
              means computer and communication”
            </h2> */}
            <h6 className="pt-3">
              <b>“தொழில்நுட்பங்களில் நுட்பங்களை தேடி ஒரு தேடல்”</b>{" "}
            </h6>
          </div>
          <div className="col-md-3 importantlinks">
            <h3 className="">Important Links</h3>
            <Link to="/about">About Us</Link>
            <br />
            <Link to="/privacypolicy">Privacy Policy</Link>
            {/* <a href={"/privacypolicy"}>Privacy Policy</a> */}
            <br />
            <Link to="/TermsConditions">Terms and Conditions</Link>
            {/* <a href={"/TermsConditions"}>Terms and Conditions</a> */}
            <br />
            <Link to="/Disclimer">Disclaimer</Link>
            {/* <a href={"/Disclimer"}>Disclaimer</a> */}
            <br />
          </div>
          <div className="col-md-3 connectwithus">
            <h3>Connect with us</h3>
            <div>
              <a
                target="_blank"
                href="https://www.facebook.com/tamizhtechieofficial"
              >
                <i className="fa fa-facebook" aria-hidden="true"></i>FaceBook
              </a>
              <br />
              <a target="_blank" href="https://www.instagram.com/tamizhtechie/">
                <i className="fa fa-instagram" aria-hidden="true"></i>Instagram
              </a>
              <br />
              <a
                target="_blank"
                href="https://www.linkedin.com/in/tamizhtechie/"
              >
                <i className="fa fa-linkedin" aria-hidden="true"></i>LinkedIn
              </a>
              <br />
              <a target="_blank" href="https://t.me/tamizhtechie">
                <i className="fa fa-telegram" aria-hidden="true"></i>Telegram
              </a>
            </div>
          </div>
        </div>

        <hr />
        <div className="row copyrights-section">
          <div className="col-6">
            <h5 className="developer">
              Copyrights 2021 @ TamizhTechie. Powered by{" "}
              <a target="_blank" href="https://babz-balaji.web.app/">
                BabzBalaji
              </a>
            </h5>
          </div>
          <div className="col-6 text-right">
            <h6>
              Connect with us :{" "}
              <a href="mailto:tamizhtechie21@gmail.com">
                {" "}
                tamizhtechie21@gmail.com
              </a>
            </h6>
          </div>
        </div>
      </div>
    </div>
  );
}
